import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import PatientTreatment from '../Components/PatientTreatment';
import { store } from '../../../store/store';
import { loadDOMComponent } from '../../../helpers';
import { AppContextProvider } from '../../../Services/AppContext';
import AclContextProvider from '../../Acl/Components/AclContextProvider';

loadDOMComponent({
	selector: 'react-patient-treatment',
	callback: ({ container, context, props }: any) => {
		const patientId = container.getAttribute('patientId');
		const caseId = container.getAttribute('caseId');
		const workplaceId = container.getAttribute('workplaceId');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<PatientTreatment
							patientId={patientId}
							caseId={caseId}
							activeTab={context?.activeTab}
							caseJustAssigned={context?.caseJustAssigned}
						/>
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
